module.exports = __webpack_public_path__ + "media/images/clock-regular-ecce16f1.svg";